import styled from 'styled-components'

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
  .rankmiTable-rowsCount {
    display: initial !important;
    margin-bottom: 22px;
  }
`
